import { putPrescanFetchFulfilled } from "./reducer";
import config from "../../../config";
import { IGcpAppDispatch } from "../../store";
import { performSignedRequest } from "../auth/asyncActions";

export const fetchPrescan =
  (customerId: string, siteId: string, scanDate: string) =>
  async (dispatch: IGcpAppDispatch) => {
    const resp = await dispatch(
      performSignedRequest(
        {
          method: "GET",
          url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/${scanDate}/prescan`,
        },
        customerId,
        siteId,
      ),
    );
    dispatch(putPrescanFetchFulfilled(resp.data.prescan));
  };

export const fetchLatestPrescan =
  (customerId: string, siteId: string) => async (dispatch: IGcpAppDispatch) => {
    const resp = await dispatch(dryFetchLatestPrescan(customerId, siteId));

    dispatch(putPrescanFetchFulfilled(resp.data.prescan));
  };

export const dryFetchLatestPrescan =
  (customerId: string, siteId: string) => async (dispatch: IGcpAppDispatch) =>
    await dispatch(
      performSignedRequest(
        {
          method: "GET",
          url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/latest-prescan`,
        },
        customerId,
        siteId,
      ),
    );
